import { IHooksUseRequestCertifyProfileParams, IHooksUseRequestEditVerificationStateParams } from '@/interfaces';
import { useCertificationCount, useCertifications } from '../../hooks';
import { ButtonFilterCountable } from '@/components/custom';
import { getSelectOptions, notify } from '@/functions';
import { useEffect, useState } from 'react';
import { useListenEvents } from '@/hooks';
import { GenderEnum } from '@/lib/enum';

type TState = Record<GenderEnum, number>;

const CONSTS = {
  initState: {
    FEMALE: 0,
    MALE: 0
  } as TState
};

const ControlsFiltersGenders = () => {

  const { isLoadingCertifications, certifications, certificationsUpdatedAt } = useCertifications();
  const { isLoadingVerificationsCount, countMale, countFemale } = useCertificationCount();
  const [state, setState] = useState<TState>(CONSTS.initState);

  useListenEvents({
    args: [certificationsUpdatedAt],
    type: 'verificationStateChanged',
    callback: (data: IHooksUseRequestEditVerificationStateParams) => {
      const gender = certifications.find(l => l._id === data.verificationId)?.userData.gender;

      if (!gender) {
        return;
      }

      setState(l => ({ ...l, [gender]: l[gender] - 1 }));
      notify('La vérification a été reporté pour traitement.');
    }
  });

  useListenEvents<IHooksUseRequestCertifyProfileParams>({
    type: 'profileCertified',
    callback: data => setState(l => ({ ...l, [data.gender]: l[data.gender] - 1 }))
  });

  useEffect(
    () => {
      setState(
        l => ({
          ...l,
          FEMALE: countFemale,
          MALE: countMale
        })
      );
    },
    [countMale, countFemale]
  );

  return (
    <div className='flex items-end space-x-2'>
      {
        getSelectOptions('GenderEnum')
          .map(
            l => (
              <ButtonFilterCountable
                enableToggle={false}
                isLoading={isLoadingVerificationsCount || isLoadingCertifications}
                count={state[l.value as GenderEnum]}
                text={`${l.title}(s)`}
                paramName='gender'
                value={l.value}
                key={l.value} />
            )
          )
      }
    </div>
  );

};

export default ControlsFiltersGenders;
